export default __webpack_public_path__ + "static/media/image25tum.baa489c3.jpg";